<template>
    <div>
        <p>
            A Project Warranty applies to a specific project and location, covering the project as a whole rather than individual powder coating or surface treatment jobs.<br />
            The project name must clearly identify the location and the associated building or item. Providing accurate project and location details is critical to correctly identify the warranty, for example: University of Canterbury Hospital, Block A.
        </p>
        <v-text-field v-model="warrantyRequest.projectName"
                      :rules="[$rules.required]"
                      label="Project Name *"></v-text-field>
        <address-input v-model:address="warrantyRequest.address" :required="true"></address-input>
        <v-radio-group label="Project Value *" v-model="warrantyRequest.totalValue" inline>
            <v-radio v-for="value in projectValues" :key="value" :label="value" :value="value"></v-radio>
        </v-radio-group>
        <v-text-field label="Estimated Project Start Date *"
                      type="date"
                      v-model="warrantyRequest.startDate"></v-text-field>
        <v-radio-group v-if="warrantyRequest.projectName && warrantyRequest.address.longitude && warrantyRequest.startDate && warrantyRequest.buildingType" label="Please select the warranty you would like to apply for *" v-model="warrantyRequest.warrantyType">
            <v-radio v-for="type in warrantyTypes" :key="type" :label="type" :value="type"></v-radio>
        </v-radio-group>
        <v-row v-if="warrantyRequest.warrantyType">
            <v-col cols="6">
                <v-radio-group v-model="warrantyRequest.buildingType" label="Please select which project type the Powder Coating is for*">
                    <v-radio :value="type.type" v-for="type in buildingTypes" :key="type.type">
                        <template v-slot:label>
                            <h4>{{type.type}}</h4>
                        </template>
                    </v-radio>
                </v-radio-group>
            </v-col>
            <v-col cols="6">
                <img src="projectclassification.png" style="width:100%" />
            </v-col>
        </v-row>
        <div v-if="warrantyRequest.buildingType">
            <v-radio-group label="Select below the substrate material being coated *" v-model="warrantyRequest.substrate" inline>
                <v-radio v-for="substrate in substrates[warrantyRequest.warrantyType]" :key="substrate" :label="substrate" :value="substrate"></v-radio>
            </v-radio-group>
            <div v-if="warrantyRequest.substrate">
                <label class="v-label">Components to be Coated</label>
                <v-row>
                    <v-col v-for="component in components[warrantyRequest.substrate]" cols="3" :key="component">
                        <v-checkbox v-model="warrantyRequest.selectedComponents" hide-details :label="component" :value="component"></v-checkbox>
                    </v-col>
                </v-row>
                <v-textarea v-if="warrantyRequest.selectedComponents.includes('Other')" label="For 'Other', please add detailed description"  v-model="warrantyRequest.otherComponents"></v-textarea>
                <v-radio-group v-if="warrantyRequest.selectedComponents.length > 0" label="Select below the site environment" v-model="warrantyRequest.environment" inline>
                    <v-radio label="Exterior" value="Exterior"></v-radio>
                    <v-radio label="Interior" value="Interior"></v-radio>
                </v-radio-group>
                <div v-if="warrantyRequest.environment == 'Exterior'">
                    <v-radio-group label="Enter distance from coastal, river and lake salt water environments" v-model="warrantyRequest.distanceSalt" inline>
                        <v-radio v-for="value in distancesSalt" :key="value" :label="value" :value="value"></v-radio>
                    </v-radio-group>
                    <corrosivity-zone v-if="warrantyRequest.address" :address="warrantyRequest.address" v-model:zone="warrantyRequest.exteriorZone"></corrosivity-zone>
                </div>
                <div v-if="warrantyRequest.environment == 'Interior'">
                    <v-radio-group label="Select the site conditions (including the corrosivity zone)" v-model="warrantyRequest.exteriorZone">
                        <v-radio v-for="value in interiorZones" :key="value" :label="value" :value="value"></v-radio>
                    </v-radio-group>
                </div>
                <v-radio-group v-if="warrantyRequest.exteriorZone" label="Select if your project is close to liquids other than coastal, river and lake salt water environments" v-model="warrantyRequest.liquadsClose" inline>
                    <v-radio v-for="value in distanceLiquads" :key="value" :label="value" :value="value"></v-radio>
                </v-radio-group>
                <v-radio-group v-if="warrantyRequest.liquadsClose && warrantyRequest.liquadsClose != 'No'" label="Please select the proximity to the Liquids" v-model="warrantyRequest.proximityLiquads" inline>
                    <v-radio v-for="value in distanceLiquads" :key="value" :label="value" :value="value"></v-radio>
                </v-radio-group>
                <v-radio-group v-if="warrantyRequest.liquadsClose && (warrantyRequest.liquadsClose != 'No' || warrantyRequest.proximityLiquads)" label="Is the projects within 500m of a Geothermal Environment?" v-model="warrantyRequest.closeGeothermal" inline>
                    <v-radio v-for="value in yesNo" :key="value" :label="value" :value="value"></v-radio>
                </v-radio-group>
                <v-radio-group v-if="warrantyRequest.closeGeothermal" label="Select if the projects micro environment is located in any of the following heavy industrial classifications" v-model="warrantyRequest.indusClose" inline>
                    <v-radio v-for="value in yesNo" :key="value" :label="value" :value="value"></v-radio>
                </v-radio-group>
            </div>
        </div>
    </div>
</template>
<style>
</style>
<script>
    function initialState() {
        return {
            loading: false,
            yesNo: [
                "Yes", "No"
            ],
            projectValues : [
                "<$5mil", "$5mil - $20mil", "$20mil - $50mil", "$50mil - $200mil", "Over $200mil", "Unknown"
            ],
            warrantyTypes: [
                'Alumi Shield',
                'Steel Shield'
            ],
            distancesSalt: [
                "Less than 10m from high tide", "Between 10 and 100m from high tide", "More than 100m from high tide"
            ],
            distanceLiquads: [
                "Chemically treated", "Clean tap, fresh or potable water", "Salt water", "Other (describe)", "No"
            ],
            proximityLiquads: [
                "Less than 1m from the liquid", "1m to 2m from the liquid (ie outside the splash zone)", "Greater than 2m from the liquid"
            ],
            interiorZones: [
                'C1 - Dry interiors (homes, offices, shops)',
                'C2 - Minor condensation (warehouses, sports halls)',
                'C3 - High moisture (dairy and food processing plants, breweries, and commercial laundries)',
                'C4 - Significant contamination'
            ],
            indusCloseList: [
                "Chemical manufacturing, storage or processing facilities and agricultural buildings",
                "Mining",
                "Transport terminals (eg, airports, train stations, carparks)",
                "No, the locations is not heavy industry"
            ],
            substrates: {
                'Alumi Shield': ['Expanded Aluminum', 'Extruded Aluminum', 'Perforated Aluminum', 'Sheet Aluminum'],
                'Steel Shield': ['Black/Blue Steel', 'Bright/Semi Bright Steel', 'Mild Steel']
            }, 
            components: {
                'Expanded Aluminum': ['Decorative Sheet (Inc Screens)', 'Other'],
                'Extruded Aluminum': ['Balustrades', 'Cladding', 'Doors', 'Lourves', 'Windows', 'Other'],
                'Perforated Aluminum': ['Balustrades', 'Decorative Sheet (Inc Screens)', 'Other'],
                'Sheet Aluminum': ['Cladding', 'Other'],
                'Black/Blue Steel': ['Other'],
                'Bright/Semi Bright Steel': ['Other'],
                'Mild Steel': ['Other']
            },
            buildingTypes: [
                {type:'Non-habitable', help: 'Non-habitable projects are those that are not dwelling types. Examples can be furniture, bus shelters, signage etc.'},
                {type: 'Residential < 4 Levels', help: 'Residential properties < 4 levels are typically easy to maintain, given their height and access.'},
                {type: 'Residental > 3 Levels', help: 'High-rise residential projects are less sheltered from neighbouring buildings, raising their exposure and reducing their ease of maintenance.'},
                {type: 'Light Commercial < 4 Levels', help: 'Light commercial projects < 4 levels are sheltered from neighbouring buildings, but require greater durability due to higher usage and wear.'},
                {type: 'Commercial > 3 Levels', help: 'High-rise commercial projects are less sheltered from neighbouring buildings, raising their exposure and reducing their ease of maintenance.'},
                {type: 'Prestigious Commercial', help: 'Prestigious commercial projects attract attention and require high quality finishes to uphold the longevity and design requirements.'},
                {type: 'Monumental', help: 'Monumental projects attract the most attention and have the highest standards required to uphold the reputation and protection expected from landmark sites.'}
            ],
            warrantyRequest: {
                warrantyType: null,
                otherComponents: '',
                selectedComponents: [],
                exteriorZone: null,
                buildingType: null,
                projectName: '',
                startDate: null,
                totalValue: null,
                substrate: null,
                environment: null,
                distanceSalt: null,
                liquadsClose: null,
                proximityLiquads: null,
                closeGeothermal: null,
                indusClose: null,
                address: {
                    address_1: '',
                    address_2: '',
                    suburb: '',
                    city: '',
                    postcode: '',
                    longitude: null,
                    latitude: null
                }
            }
        };
    }
    export default {
        name: "WarrantyApplication",
        data: function () {
            return initialState();
        },
        mounted: function () {
        },
        props: {
        },
        methods: {
        },
        computed: {
        }
    };
</script>